import { useTranslation } from 'react-i18next'

import { BracketsPlusIcon, Button, ButtonMenu } from '@reveni-io/reveni-ui'

import VariableLabel from '../VariableLabel/VariableLabel'

const AddVariablesButton = ({
  onAddVariable,
  withLabel = true,
  label = 'Insertar variable',
  availableVariables,
  availableSections,
  disabled,
}) => {
  const { t } = useTranslation()

  return (
    <ButtonMenu
      disabled={disabled}
      sections={availableSections?.map(vs => ({ ...vs, label: t(vs.label) }))}
      menuItems={availableVariables?.map(v => ({
        ...v,
        onClick: onAddVariable,
        label: (
          <VariableLabel withoutMarginLeft type={v.type} label={v.label} variable={v.variable} example={v.example} />
        ),
      }))}
      renderButton={onClick => (
        <Button variant="text" size="s" onClick={onClick} disabled={disabled}>
          <BracketsPlusIcon />
          {withLabel && t(label)}
        </Button>
      )}
    />
  )
}

export default AddVariablesButton
